export default __webpack_public_path__ + "static/media/unique_ratio.87846d91.svg";